module.exports = __webpack_public_path__ + "assets/img/_Novo RDR_Jacuzzi_RGB_lr.3bb3ed1c.jpg";